import React, { useState, useEffect } from "react";
import { makeStyles, Paper, Grid } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { Select } from "antd";

import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import { heatMapColors } from "../../../shared-resources/dumpData";
import { updateHeatMapAPI } from "../../../api/financial-management-api";
import { convertValuesFM } from "../../../shared-resources/utils";

// const colData = {
//   financial: null,
//   perform: null,
//   funding: null,
//   staffing: null,
//   culture: null,
//   customer: null,
//   doge: null,
//   vacantFte: 0,
// };

const useStyles = makeStyles((theme) => ({
  editBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "2px 8px",
    cursor: "pointer",
    float: "right",
    margin: "6px 6px 6px 0",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
  },
  saveBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginRight: "8px",
  },
  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
    float: "left",
    marginTop: "2px",
  },
  editText: {
    color: "#0070D2",
    marginLeft: "4px",
    fontWeight: 600,
    fontSize: "13px",
  },
}));

const colItems = [
  "financial",
  "perform",
  "funding",
  "staffing",
  "culture",
  "customer",
  "doge",
];

const HeatMapContractSummary = ({
  heatMapData,
  selectedContract,
  showAddHeatMap,
}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [orginalData, setOrginalData] = useState([]);
  const [data, setData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  const handleClickEdit = () => {
    setIsEdit(true);
  };

  const onSaveClick = () => {
    setLoading(true);
    updateHeatMapAPI(data, selectedContract).then((res) => {
      if (res.status === 200) {
        setIsEdit(false);
        setLoading(false);
        setEmptyErrMsg(true);
        setMsgType("success");
        setMsgText("Data updated successfully");
      }
      if (res.status === 400) {
        setLoading(false);
        setEmptyErrMsg(true);
        setMsgType("error");
        setMsgText(res.data.message);
      }
    });
  };

  const onCancelClick = () => {
    setData(orginalData);
    setIsEdit(false);
  };

  const onChangeColor = (id, key, val) => {
    let newData = JSON.parse(JSON.stringify(data));
    const itemIndex = newData.findIndex((item) => item.id === id);
    newData[itemIndex][key] = val;
    setData(newData);
  };

  useEffect(() => {
    if (heatMapData) {
      setLoading(false);
      setData(heatMapData);
      setOrginalData(heatMapData);
    } else {
      setData(heatMapData);
      setOrginalData(heatMapData);
    }
  }, [heatMapData]);

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onValidateNumber = (e) => {
    const changeVal = ["-", ""].includes(e.target.value.trim())
      ? 0
      : e.target.value;
    var validNumber = new RegExp(/^-?[0-9]\d*(\.\d+)?$/);
    if (
      (!validNumber.test(changeVal) && !changeVal.toString().includes(".")) ||
      changeVal.toString().split(".").length - 1 > 1
    )
      return { isValid: false, changeVal: 0 };
    return { isValid: true, changeVal: Number(changeVal) };
  };

  const onChangeNoOfFte = (e, id) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    // let newData = { ...data };
    // newData.vacantFte = changeVal;
    let newData = JSON.parse(JSON.stringify(data));
    const itemIndex = newData.findIndex((item) => item.id === id);
    newData[itemIndex].vacantFte = changeVal;
    setData(newData);
  };

  const handleAdd = () => {
    showAddHeatMap(true);
  };

  return (
    <>
      {!isEdit ? (
        <>
          {data && (
            <div
              className={classes.editBtn}
              onClick={handleClickEdit}
              style={{ marginTop: "-6px" }}
            >
              <EditIcon className={classes.editIcon} />
              <span className={classes.editText}>Edit</span>
            </div>
          )}

          <div
            className={classes.editBtn}
            onClick={handleAdd}
            style={{ marginTop: "-6px" }}
          >
            <span className={classes.editText}>Add</span>
          </div>
        </>
      ) : (
        <div style={{ float: "right", margin: "6px  6px 6px 0" }}>
          <span className={classes.saveBtn} onClick={() => onSaveClick(false)}>
            <span className={classes.editText}>Save</span>
          </span>
          <span className={classes.cancelBtn} onClick={onCancelClick}>
            <span className={classes.editText}>Cancel</span>
          </span>
        </div>
      )}
      <table cellPadding={0} cellSpacing={0} className="heatmapTable">
        <thead>
          <tr>
            <td>Clin</td>
            <td>Financial</td>
            <td>Perform</td>
            <td>Funding</td>
            <td>Staffing</td>
            <td>Culture</td>
            <td>Customer</td>
            <td>Doge</td>
            <td>No of Vacant FTE</td>
          </tr>
        </thead>
        <tbody>
          {data ? (
            data.map((item) => (
              <tr>
                <td>{item.clin}</td>
                {colItems.map((col) => (
                  <td>
                    {isEdit ? (
                      <Select
                        showSearch
                        mode="single"
                        style={{ width: "95%", zIndex: 9 }}
                        placeholder="Search to Select"
                        showArrow
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label.toLowerCase() ?? "").includes(
                            input.toLowerCase()
                          )
                        }
                        options={heatMapColors}
                        onChange={(val) => onChangeColor(item.id, col, val)}
                        value={item[col]}
                      />
                    ) : (
                      <span
                        style={{
                          width: "60px",
                          height: "18px",
                          display: "inline-block",
                          borderRadius: "4px",
                          background: item[col] ? item[col] : "#d9d7d7",
                        }}
                      ></span>
                    )}
                  </td>
                ))}
                <td>
                  {isEdit ? (
                    <input
                      type="text"
                      style={{
                        width: "120px",
                        border: "1px solid #ccc",
                        borderRadius: "3px",
                        padding: "6px 2px",
                      }}
                      defaultValue={convertValuesFM(item.vacantFte, "")}
                      onChange={(e) => onChangeNoOfFte(e, item.id)}
                    />
                  ) : (
                    convertValuesFM(item.vacantFte, "")
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={9}
                style={{ textAlign: "center", fontWeight: "600" }}
              >
                No Data
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
    </>
  );
};

export default HeatMapContractSummary;
